import { action, observable } from 'mobx';
import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import { getPageCmsArticle } from '@src/services/page-cms-content';

const CMS_ID = 11986;

class Page3Store extends BaseStore {
  @observable contentHtml = '';

  use() {
    super.use();

    useMount(() => {
      let isMounted = true;

      getPageCmsArticle(CMS_ID).then(
        action(article => {
          if (isMounted) {
            this.contentHtml = article?.content || '';
          }
        }),
        () => undefined
      );

      return () => {
        isMounted = false;
      };
    });
  }
}

export default Page3Store;
